import { z, isoZ } from 'my-zod'
import { productLineOptions } from '../../internal/product-lines'
import { ibmiProductLineEnum } from '../../internal/ibmi-product-line'

export const modelsModel = z.object({
  id: z.number().int(),
  modelNumber: z.string().max(20).nullable(),
  productLine: z.enum(productLineOptions).nullable(),
  modelYear: z.string().nullable(),
  modelName: z.string().max(45).nullable(),
  msrp: z.number().min(0).nullable(),
  ibmiProductLine: ibmiProductLineEnum.nullable().setLabel('IBMI Product Line'),
  ibmiSalesFamily: z.string().nullable().setLabel('IBMI Sales Family'),
  ibmiProductLineCode: z.string().nullable().setLabel('IBMI Product Line Code'),
  ibmiModelImageUrl: z.string().url().max(512).nullable().setLabel('IBMI Model Image Url'),
  modelGroupId: z.number().int().nullable(),
  manuallyReviewed: z.boolean(),
  isAutoCreated: z.boolean().setLabel('Auto Created'),
  createdDate: isoZ.instant(),
  lastModifiedDate: isoZ.instant().nullable(),
  deletedDate: isoZ.instant().nullable()
})

export type modelsModel = z.infer<typeof modelsModel>
